import videos_produced_per_year from './videos_produced_per_year.json';
import videos_produced_per_month from './videos_produced_per_month.json';
import videos_produced_per_day from './videos_produced_per_day.json';
import videos_opened_per_day from './videos_opened_per_day.json';
import videos_watched_per_month from './videos_watched_per_month.json';

const reports = {
    sections: [
        {
            title: "Geproduceerd",
            reports: [
                videos_produced_per_year,
                videos_produced_per_month,
                videos_produced_per_day,
            ]
        },
        {
            title: "Geopend",
            reports: [
                videos_opened_per_day,
            ]
        },
        {
            title: "Bekeken",
            reports: [
                videos_watched_per_month,
            ]
        }
    ],
}

export default reports;